import { useDirectFlow } from 'new/components/flows/types/DirectFlow/hooks/useDirectFlow';
import useCredentialsPage from 'new/components/flows/controller/useCredentialsPage';
import { FORM_TYPE_CREATE_DIRECT_FLOW } from 'js/constants/formTypes';
import { loadDataCredentials, loadFullVendor } from 'js/actions';
import { ACLQueryModeTypes } from 'js/constants/visibilityFilters';
import { Dispatch, useMemo } from 'react';
import { useDispatch } from 'react-redux';

const reloadCredentialsNeeds = (dispatch: Dispatch<any>, selectedConnection: string) => () => {
  dispatch(loadFullVendor(selectedConnection));
  dispatch(loadDataCredentials(ACLQueryModeTypes.MODE_COLLABORATOR.key));
};

export const useAuthenticateStep = () => {
  const dispatch = useDispatch();
  const { credentialId, selectedConnection } = useDirectFlow();

  const {
    onSaveCredential,
    onChangeTemplate,
    selectedTemplate,
    onEditCredential,
    onCredentialSelected,
    onCredentialInfoUpdated,
  } = useCredentialsPage({
    useFormData: useDirectFlow,
    formType: FORM_TYPE_CREATE_DIRECT_FLOW,
  });

  const reloadCredentials = useMemo(
    () => reloadCredentialsNeeds(dispatch, selectedConnection),
    [selectedConnection],
  );

  return {
    reloadCredentials,
    credentialId,
    selectedConnection,
    onChangeTemplate,
    selectedTemplate,
    onSaveCredential,
    onEditCredential,
    onCredentialSelected,
    onCredentialInfoUpdated,
  };
};
